import type { SVGProps } from "react";

export default function BookmarkMessageIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      {...props}
    >
      <path
        d="M11.667 8.93936V6.16525C11.667 3.7827 11.667 2.59142 10.9348 1.85125C10.2025 1.11108 9.02399 1.11108 6.66699 1.11108C4.30997 1.11108 3.13146 1.11108 2.39923 1.85125C1.66699 2.59142 1.66699 3.7827 1.66699 6.16525V8.93936C1.66699 10.6597 1.66699 11.5199 2.07483 11.8957C2.26933 12.075 2.51485 12.1876 2.77639 12.2175C3.32478 12.2803 3.96518 11.7138 5.24597 10.581C5.8121 10.0802 6.09522 9.82986 6.42272 9.76392C6.58399 9.73142 6.74999 9.73142 6.91127 9.76392C7.23877 9.82986 7.52188 10.0802 8.08799 10.581C9.36883 11.7138 10.0092 12.2803 10.5576 12.2175C10.8192 12.1876 11.0647 12.075 11.2592 11.8957C11.667 11.5199 11.667 10.6597 11.667 8.93936Z"
        strokeWidth="0.836854"
        stroke="white"
      />
      <path
        d="M8.33333 3.33325H5"
        strokeWidth="0.836854"
        strokeLinecap="round"
        stroke="white"
      />
    </svg>
  );
}
